import { render, staticRenderFns } from "./SettingMetadata.vue?vue&type=template&id=ded96504&scoped=true&"
import script from "./SettingMetadata.vue?vue&type=script&lang=js&"
export * from "./SettingMetadata.vue?vue&type=script&lang=js&"
import style0 from "./SettingMetadata.vue?vue&type=style&index=0&id=ded96504&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded96504",
  null
  
)

export default component.exports